import React from 'react'
import ModalConsulta from './ModalConsulta';
import { Tabela } from '../Basicos';

function ModalConsultaGruposRodizio(props) {
    const { estrutura } = props;
    const { gruposRodizio } = estrutura?.modal;

    const columns = React.useMemo(
        () => [{
            Header: "gruposRodizio",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Grupo',
                    accessor: 'grupo',
                },
                {
                    Header: 'Matrícula',
                    accessor: 'matricula',
                },
                {
                    Header: 'Aluno',
                    accessor: 'aluno',
                },
                {
                    Header: 'Serviço',
                    accessor: 'servico',
                },
                {
                    Header: 'Quantidade Prevista',
                    accessor: 'qtd_rodizio',
                },
                {
                    Header: 'Quantidade Alocada',
                    accessor: 'qtd_alocada',
                },
            ],
        }],
        []
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"

            {...props}
        >
            <Tabela
                columns={columns}
                data={gruposRodizio}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalConsultaGruposRodizio;
